import { ArrowUpRight } from "lucide-react";

const footerLinks = [
  {
    heading: "Services",
    links: ["HACCP Systems", "Allergen Management", "Staff Training", "Temperature Logs"],
  },
  {
    heading: "Packages",
    links: ["Starter Pack", "Audit + Action Plan", "Tailored HACCP", "Done-For-You"],
  },
  {
    heading: "Legal",
    links: ["Privacy Policy", "Terms of Service", "Cookie Policy"],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-black border-t border-[#c9a84c]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-xl font-semibold text-white">
              Chef <span className="text-gold">Compliance</span> UK
            </span>
            <p className="text-sm text-zinc-600 mt-4 leading-relaxed max-w-xs">
              Professional food safety documentation & HACCP compliance for the
              modern UK food business.
            </p>
            <p className="text-xs text-zinc-700 mt-3">
              Danny Davies &middot; Founder & Director
            </p>
          </div>

          {footerLinks.map((col) => (
            <div key={col.heading}>
              <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-500 mb-4">
                {col.heading}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-zinc-500 hover:text-gold transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Giant CTA */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pb-16">
        <a
          href="#contact"
          data-testid="footer-cta-link"
          className="group flex items-center justify-between border-t border-[#c9a84c]/10 pt-10"
        >
          <span className="font-heading text-[10vw] md:text-[7vw] font-medium text-white/[0.04] group-hover:text-[#c9a84c]/10 transition-colors duration-500 leading-none tracking-tighter">
            GET EHO READY
          </span>
          <ArrowUpRight
            size={42}
            className="text-zinc-800 group-hover:text-gold transition-colors duration-300 flex-shrink-0"
          />
        </a>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/5 py-5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex flex-col items-center gap-2">
          <div className="w-full flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-xs text-zinc-700">
              &copy; {new Date().getFullYear()} Chef Compliance UK. All rights reserved.
            </p>
            <p className="text-xs text-zinc-700">
              chefcomplianceuk.com &middot; Info@chefcomplianceuk.com
            </p>
          </div>
          <p data-testid="powered-by-jrt" className="text-[10px] text-zinc-600 tracking-wider mt-2 flex items-center justify-center gap-1.5">
            <img
              src="https://customer-assets.emergentagent.com/job_site-creator-2145/artifacts/adkztr9t_9076.jpg"
              alt="JRT Chideme Media"
              className="w-4 h-4 rounded-full object-cover"
            />
            Powered by <a href="https://www.jrtchidememedia.co.uk" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline hover:drop-shadow-[0_0_6px_rgba(201,168,76,0.4)] transition-all">JRT Chideme Media</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
